
// export const BASE_URL = 'http://127.0.0.1:8000/';
export const BASE_URL = 'https://ciw.codeinfoway.com/api/';

export const RAZORPAY_LIVE_KEY_ID = 'rzp_test_B8vnHNOYgj0Cyy';
